import { Text6, Text3, Text2, Spinner, EmptyState, RowList, Row, skinVars, IconSmsRegular } from '@telefonica/mistica';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSearchParams } from 'react-router-dom';
import { ErrorStateUIData } from '../../../models/interfaces';
import { getAllConsDetail } from '../../../services/ConsumptionService';
import { dateToLongMonth, getFormatDate } from '../../../utils/dataTransformation/dateConversions';
import { setInfoError } from '../../../utils/dataTransformation/errorMesssages';
import { formatMobileNumber, formatPrices } from '../../../utils/dataTransformation/unitsConversion';
import './index.scss';

const DetailConsumptionSMS: React.FC = () => {
    const [isLoading, setLoading] = useState(true);
    const [listSMS, setListSMS] = useState([]);
    const [searchParams] = useSearchParams();
    const productPsId: any = searchParams.get('productPsId');
    const [page, setPage] = useState(1);
    const [moreElements, setMoreElements] = useState(true);
    const [error, setError] = useState<ErrorStateUIData>({ title: '', localizedDescription: '', id: '' });
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        setPage(1);
        setListSMS([]);
        setMoreElements(false);
        getMoreDetails();
    }, []);

    const getMoreDetails = () => {
        const params = {
            productPsId: productPsId,
            consumptionType: 'SMS',
            page: page,
            size: 25,
        };
        setLoading(true);
        getAllConsDetail(params)
            .then((res: any) => {
                const data = res.data.details;
                setListSMS(listSMS.concat(data));
                setPage(page + 1);
                setMoreElements(res.data.moreElements);
                setLoading(false);
            })
            .catch((err) => {
                setError(setInfoError(err));
                setHasError(true);
                setLoading(false);
            });
    };

    if (isLoading) {
        return (
            <div className='extraExpenseDetails-page'>
                {' '}
                <div className='extraExpenseDetails-page__loading'>
                    <div className='extraExpenseDetails-page__loading__spinner'>
                        <Spinner size={'32px'} color={skinVars.colors.navigationBarBackground}></Spinner>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className='DetailConsumptionSms'>
            {!isLoading && !hasError && listSMS.length > 0 ? (
                <InfiniteScroll
                    dataLength={listSMS.length}
                    next={getMoreDetails}
                    hasMore={moreElements}
                    loader={<h4>Loading...</h4>}
                >
                    <RowList>
                        {listSMS.map((item: any, index: number) => {
                            let pivot = ' ';
                            const longMonth = dateToLongMonth(item.dateTime.substring(5, 7));
                            if (index != 0) {
                                const value: any = listSMS[index - 1];
                                pivot = value.dateTime.substring(8, 10);
                            }
                            if (index == 0) {
                                return (
                                    <div key={index}>
                                        <div className='DetailConsumptionSms__item-text'>
                                            <Text3 medium color={skinVars.colors.textSecondary}>
                                                {item.dateTime.substring(8, 10)} {longMonth}
                                            </Text3>
                                        </div>

                                        <Row
                                            title=''
                                            asset={''}
                                            right={
                                                <div>
                                                    <Text6
                                                        color={
                                                            item.cost > 0
                                                                ? skinVars.colors.errorHigh
                                                                : skinVars.colors.textPrimary
                                                        }
                                                    >
                                                        {formatPrices(item.cost, 'spent')}
                                                    </Text6>
                                                </div>
                                            }
                                            headline={
                                                <div className='DetailConsumptionSms__row-headline'>
                                                    <div className='DetailConsumptionSms__row-headline-consumption'>
                                                        <div>
                                                            <Text3 regular>{formatMobileNumber(item.number)}</Text3>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            extra={
                                                <div>
                                                    <Text2 regular color={skinVars.colors.textSecondary}>
                                                        {getFormatDate(item.dateTime, '00:00')} - SMS
                                                    </Text2>
                                                </div>
                                            }
                                        ></Row>
                                    </div>
                                );
                            } else if (pivot != item.dateTime.substring(8, 10)) {
                                return (
                                    <div key={index}>
                                        <div className='DetailConsumptionSms__item-text'>
                                            <Text3 medium color={skinVars.colors.textSecondary}>
                                                {getFormatDate(item.dateTime, '00 MMMM')}
                                            </Text3>
                                        </div>

                                        <Row
                                            title=''
                                            asset={''}
                                            right={
                                                <div>
                                                    <Text6
                                                        color={
                                                            item.cost > 0
                                                                ? skinVars.colors.errorHigh
                                                                : skinVars.colors.textPrimary
                                                        }
                                                    >
                                                        {formatPrices(item.cost, 'spent')}
                                                    </Text6>
                                                </div>
                                            }
                                            headline={
                                                <div className='DetailConsumptionSms__row-headline'>
                                                    <div className='DetailConsumptionSms__row-headline-consumption'>
                                                        <div>
                                                            <Text3 regular>{formatMobileNumber(item.number)}</Text3>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            extra={
                                                <div>
                                                    <Text2 regular color={skinVars.colors.textSecondary}>
                                                        {getFormatDate(item.dateTime, '00:00')} - SMS
                                                    </Text2>
                                                </div>
                                            }
                                        ></Row>
                                    </div>
                                );
                            } else {
                                return (
                                    <div key={index}>
                                        <Row
                                            title=''
                                            asset={''}
                                            right={
                                                <div>
                                                    <Text6
                                                        color={
                                                            item.cost > 0
                                                                ? skinVars.colors.errorHigh
                                                                : skinVars.colors.textPrimary
                                                        }
                                                    >
                                                        {formatPrices(item.cost, 'spent')}
                                                    </Text6>
                                                </div>
                                            }
                                            headline={
                                                <div className='DetailConsumptionSms__row-headline'>
                                                    <div className='DetailConsumptionSms__row-headline-consumption'>
                                                        <div>
                                                            <Text3 regular>{formatMobileNumber(item.number)}</Text3>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            extra={
                                                <div>
                                                    <Text2 regular color={skinVars.colors.textSecondary}>
                                                        {getFormatDate(item.dateTime, '00:00')} - SMS
                                                    </Text2>
                                                </div>
                                            }
                                        ></Row>
                                    </div>
                                );
                            }
                        })}
                    </RowList>
                </InfiniteScroll>
            ) : (
                !hasError && (
                    <div className='DetailConsumptionSms__emptyState'>
                        <EmptyState
                            icon={<IconSmsRegular color={skinVars.colors.brand} size={64} />}
                            title={t('titleSMSDetails')}
                            description={t('descriptionSMSDetails')}
                        ></EmptyState>
                    </div>
                )
            )}
        </div>
    );
};

export default DetailConsumptionSMS;
